import React from "react";

function Div1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="196"
      height="129"
      fill="none"
      viewBox="0 0 196 129"
    >
      <g filter="url(#filter0_d_255_1049)">
        <path
          stroke="#61FF00"
          strokeWidth="0.657"
          d="M185.064 97.516l-30.839 20.607H51.084M11 36.375l25.357-25.318h105.882"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_255_1049"
          width="195.498"
          height="128.742"
          x="0.258"
          y="0.219"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="5.255"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.38 0 0 0 0 1 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_255_1049"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_255_1049"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default Div1;
